import type { ButtonHTMLAttributes } from 'react';

/**
 * Props for the Button component.
 */
export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * Visual variant controlling the button style.
   * @default 'primary'
   */
  variant?: 'primary' | 'secondary' | 'danger';
}

/**
 * Shared button component used across Web, Dashboard and Scanner.
 * Exposes the variant via a `data-variant` attribute for CSS styling.
 *
 * @param props.variant - Button style variant (primary | secondary | danger)
 * @example
 * ```tsx
 * <Button variant="primary" onClick={handleSave}>Save</Button>
 * <Button variant="danger" onClick={handleDelete}>Delete</Button>
 * ```
 */
export const Button = ({ variant = 'primary', children, ...props }: ButtonProps) => (
  <button data-variant={variant} {...props}>
    {children}
  </button>
);
